<template>
  <div class="page-content">
    <div class="page-title">ASSOCIATIONS AND CLUBS FOR UNESCO A PRACTICAL GUIDE</div>
    <div class="text">
      The Clubs, Centres and Associations for UNESCO are groups of volunteers of different ages and
      socio-professional status who become activists in the service of UNESCO’s ideals. <br />
      Over four thousand Clubs, Centres and Associations for UNESCO operate in about eighty
      countries. Please visit the document below for the global list of Associations, Centres and
      Clubs for UNESCO, which was updated by UNESCO in November 2020.
    </div>
    <div class="sub-title">FOREWORD</div>
    <div class="text-title">
      Foreword by Assistant Director- General for Priority Africa and External Relations
    </div>
    <div class="text">
      “We the Peoples”... with this simple introduction, the Charter of the United <br />
      Nations sets out an ambitious and noble mandate. The impetus to create such an organization
      came from an understanding that a global framework for collaboration was essential to avoid a
      recurrence of worldwide armed conflict. Yet today, 75 years later, scepticism is growing
      worldwide about the value of multilateralism, and the United Nations as well as UNESCO face
      the challenge of remaining relevant and effective, especially for those whom it is meant to
      serve, the peoples themselves. <br />
      As highlighted in the outcome document of the 67th United Nations DPI-NGO Conference (New
      York, 2018), “the ambition of the 2030 Agenda for Sustainable Development, driven by pressing
      transnational problems like climate change, demands the deeper and more equitable cooperation.
      People-centred multilateralism requires expanding the role of civil society partnerships,
      especially with youth, to advance the Sustainable Development Goals (SDGs). Since more than
      half of the world’s population is under 30 years old, young people are key partners... to
      further the 2030 Agenda for Sustainable Development and ensure that no one is left behind”.
      <br />
      As a specialized agency of the United Nations, UNESCO has been systematically involving
      various partners in its action to maximize the means to effectively accomplish its mission and
      contribute to the implementation of the 2030 Agenda. Indeed, UNESCO’s advantage lies in its
      ability to create a genuine culture of partnership with civil society in the various
      programmes and at all levels. <br />
      In close cooperation with National Commissions for UNESCO, our Organization has for over 75
      years endeavoured to establish an unparalleled range of partnerships and networks at county
      level, which today constitutes one of its most significant assets. This important community,
      also known as the UNESCO Family in Member States, includes among others Associations and Clubs
      for UNESCO. <br />
      Made up mostly of young people, Associations and Clubs for UNESCO play an important role in
      continually lending a fresh and creative approach to promoting UNESCO ideals and achieving the
      goals of the 2030 Agenda. They foster cooperation and value the bonds of local communities and
      their capacity to effect lasting change. As technology is changing the information landscape,
      more activities and development opportunities are needed to empower skills in young people.
      <br />
      This updated guide is designed for anyone interested in contributing to a global grassroots
      movement. This is a basic practical manual for setting up an Association or a Club for UNESCO.
      It is for individuals and groups, who wish to be a part of humanity’s solution and believe in
      a sustainable world community that can think globally and act locally. <br />
      This guide also provides basic information about UNESCO’s ideals and offers general ideas on
      how to maximize a community’s outreach capacity. I hope this guide will be useful to all
      current and future members of the Clubs movement and inspire them to serve the great ideals of
      our Organization and act in support of the 2030 Agenda.
    </div>

    <div class="img-right">
      <img src="@/assets/images/clubs/img02.png" />
    </div>

    <div class="a-lsit">
      <!--      <div class="a" @click="goPdf()">I. WHAT ISUNESCO?</div>-->
      <!--      <div class="a" @click="goPdf()">II. WHAT ARE ASSOCIATIONS AND CLUBS FOR UNESCO?</div>-->
      <!--      <div class="a" @click="goPdf()">III. WHY CREATE AN ASSOCIATION OR A CLUB FOR UNESCO?</div>-->
      <!--      <div class="a" @click="goPdf()">-->
      <!--        IV. STRUCTURE AND OPERATIONS OF ASSOCIATIONS AND CLUBS FOR UNESC-->
      <!--      </div>-->
      <!--      <div class="a">V. ANNEX</div>-->
      <div class="a" @click="downPdf()">Download the file</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {
    goPdf() {
      this.$emit("goPdf");
    },
    downPdf() {
      // window.open('/Global List of Associations and Clubs for UNESCO_20240206.pdf')
      //2.pdf name :Associations and Clubs for UNESCO a practical guide, 2021 edition_En
      // window.open("/2.pdf");
      window.open("/Associations and Clubs for UNESCO a practical guide, 2021 edition_En.pdf");
    },
  },
};
</script>
<style lang="scss" scoped>
.page-content {
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
  }
  > img {
    width: 100%;
    display: block;
  }
  .a-lsit {
    margin-top: fh(40vh, pc);
    .a {
      font-weight: bold;
      font-size: fh(24vh, pc);
      color: #333333;
      line-height: fh(30vh, pc);
      margin-bottom: fh(18vh, pc);
      text-decoration: underline;
      &:hover {
        cursor: pointer;
        opacity: 0.8;
      }
    }
  }
  .img-right {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    img {
      width: fw(200vw, pc);
      display: block;
    }
  }
  .text-title {
    font-size: fh(20vh, pc);
    line-height: fh(28vh, pc);
    margin-bottom: fh(20vh, pc);
    font-weight: bold;
    color: #333333;
  }
  .sub-title {
    margin: fh(20vh, pc) 0;
    font-size: fh(24vh, pc);
    line-height: fh(54vh, pc);
    font-weight: bold;
    color: #333333;
  }
  .text {
    // margin-top: fh(55vh, pc);
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(28vh, pc);
  }
  .more-btn {
    margin: fh(50vh, pc) auto;
  }
}
</style>
